import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { useAppSelector } from "../hooks";
import type { RootState } from "../store";

export interface LocaleState {
  locale: string;
  currency: string;
}

const initialState: LocaleState = {
  locale: "es-CL", // fallback locale
  currency: "CLP", // fallback currency
};

const localeSlice = createSlice({
  name: "locale",
  initialState,
  reducers: {
    setLocale: (state, action: PayloadAction<string>) => {
      const newLocale = action.payload;
      state.locale = newLocale;
    },
    setCurrency: (state, action: PayloadAction<string>) => {
      state.currency = action.payload;
    },
    setLocaleAndCurrency: (state, action: PayloadAction<{ locale: string; currency: string }>) => {
      state.locale = action.payload.locale;
      state.currency = action.payload.currency;
      // console.log("currency changed from layout: ", state.currency);
    },
  },
});

export const selectLocale = (state: RootState) => state.locale.locale;
export const selectCurrency = (state: RootState) => state.locale.currency;
export const useLocale = () => useAppSelector((s) => s.locale.locale);

export const { setLocale, setCurrency, setLocaleAndCurrency } = localeSlice.actions;

export default localeSlice.reducer;
